"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/teamSectionTwo.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSectionTwo36FadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Diana Williams" | "George Pearson" | "Jannie Morales" | "Mark Bowman" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/team/team-skin-1.png" | "/Templates/Doccure/img/team/team-skin-2.png" | "/Templates/Doccure/img/team/team-skin-3.png" | "/Templates/Doccure/img/team/team-skin-4.png" */
    src: string;
    /** Detected variants: "Diana Williams" | "George Pearson" | "Jannie Morales" | "Mark Bowman" */
    link0Text: ReactNode;
    /** Detected variants: "Medical Facial Specialists" | "Skin Allergy Expert" | "Chemical Peel Specialists" | "Acne Treatment Specialists" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "team-item-fourteen flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "team-img" */
    div0ClassName2?: string;
    /** Detected variants: "add-icon" */
    button0ClassName?: string;
    /** Detected variants: "isax isax-add" */
    i0ClassName?: string;
    /** Detected variants: "hover-icons" */
    div0ClassName3?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "team-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    link0Href?: string;
    socialIconsItems?: TeamSectionTwoDivsItem[];
};

type TeamSectionTwoDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "facebook" | "twitter" | "instagram" | "linkedin" */
    ariaLabel: string;
    /** Detected variants: "fab fa-facebook-f" | "fab fa-twitter" | "fab fa-instagram" | "fab fa-linkedin-in" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFourteenTeamSectionTwoGeneratedProps = {
    divDiv0Div0Div0Button0ButtonProps?: Partial<ComponentProps<"button">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<"button">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionTwoDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Making" */
    sectionDiv0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Professionals" */
    sectionDiv0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Your Skin Beauty" */
    sectionDiv0Div0Div0H20Span1SpanText?: ReactNode;
    /** Default: "all_routes.mapGrid" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All Members" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/team-bg-02.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    teamSectionTwo36FadeInUps: TeamSectionTwo36FadeInUpsItem[];
    teamSectionTwo36FadeInUpsItemWrapper?: (item: TeamSectionTwo36FadeInUpsItem, content: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsLinkVisible?: boolean;
    teamSectionTwo36FadeInUpsLinkRenderer?: (item: TeamSectionTwo36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsImageVisible?: boolean;
    teamSectionTwo36FadeInUpsImageRenderer?: (item: TeamSectionTwo36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsButtonVisible?: boolean;
    teamSectionTwo36FadeInUpsButtonRenderer?: (item: TeamSectionTwo36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsH3Visible?: boolean;
    teamSectionTwo36FadeInUpsH3Renderer?: (item: TeamSectionTwo36FadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionTwo36FadeInUpsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSectionTwo36FadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSectionTwo36FadeInUpsButtonProps?: Partial<ComponentProps<"button">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<"button">>);
    teamSectionTwo36FadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSectionTwo36FadeInUpsItem) => Partial<ComponentProps<"h3">>);
    teamSectionTwoDivsItemWrapper?: (item: TeamSectionTwoDivsItem, content: ReactNode) => ReactNode;
    teamSectionTwoDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSectionTwoDivsLinkVisible?: boolean;
    teamSectionTwoDivsLinkRenderer?: (item: TeamSectionTwoDivsItem, defaultNode: ReactNode) => ReactNode;
    teamSectionTwoDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSectionTwoDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFourteenTeamSectionTwoGenerated: FC<HomeFourteenTeamSectionTwoGeneratedProps> = ({
    sectionDiv0Div0Div0H20H2Text = "Making",
    sectionDiv0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0H20H2Props,
    sectionDiv0Div0Div0H20Span0SpanText = "Professionals",
    sectionDiv0Div0Div0H20Span1SpanText = "Your Skin Beauty",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Link0LinkHref = "all_routes.mapGrid",
    sectionDiv0Div0Link0LinkText = "View All Members",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/team-bg-02.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0Div0Button0ButtonProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    linkLinkProps,
    sectionDiv0Div1ClassName,
    teamSectionTwo36FadeInUps,
    teamSectionTwo36FadeInUpsItemWrapper,
    teamSectionTwo36FadeInUpsRenderer,
    teamSectionTwo36FadeInUpsLinkVisible,
    teamSectionTwo36FadeInUpsLinkRenderer,
    teamSectionTwo36FadeInUpsImageVisible,
    teamSectionTwo36FadeInUpsImageRenderer,
    teamSectionTwo36FadeInUpsButtonVisible,
    teamSectionTwo36FadeInUpsButtonRenderer,
    teamSectionTwo36FadeInUpsH3Visible,
    teamSectionTwo36FadeInUpsH3Renderer,
    teamSectionTwo36FadeInUpsLinkProps,
    teamSectionTwo36FadeInUpsImageProps,
    teamSectionTwo36FadeInUpsButtonProps,
    teamSectionTwo36FadeInUpsH3Props,
    teamSectionTwoDivsItemWrapper,
    teamSectionTwoDivsRenderer,
    teamSectionTwoDivsLinkVisible,
    teamSectionTwoDivsLinkRenderer,
    teamSectionTwoDivsLinkProps,
}) => {
    return (
        <section className="team-section-fourteen section">
            <div className="container">
                <div className="section-header section-header-fourteen title-white section-btn wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div>
                        {renderNode(sectionDiv0Div0Div0H20H2Visible, sectionDiv0Div0Div0H20H2Renderer, (
                            <h2 className="section-title" {...(sectionDiv0Div0Div0H20H2Props ?? {})}>
                                <span className="section-line">{sectionDiv0Div0Div0H20Span0SpanText}</span>
                                {sectionDiv0Div0Div0H20H2Text}
                                {" "}
                                <span className="subtitle">{sectionDiv0Div0Div0H20Span1SpanText}</span>
                            </h2>
                        ))}
                    </div>
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn btn-secondary theme-14-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            <i className="isax isax-bubble5 me-2" />
                            {sectionDiv0Div0Link0LinkText}
                        </SmartLink>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        teamSectionTwo36FadeInUps,
                        (item: TeamSectionTwo36FadeInUpsItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 d-flex wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-fourteen flex-fill"}>
                                    <div className={item.div0ClassName2 ?? "team-img"}>
                                        {renderItemNode(teamSectionTwo36FadeInUpsLinkVisible, teamSectionTwo36FadeInUpsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.doctorProfile1"} {...(typeof teamSectionTwo36FadeInUpsLinkProps === "function" ? teamSectionTwo36FadeInUpsLinkProps(item) : (teamSectionTwo36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(teamSectionTwo36FadeInUpsImageVisible, teamSectionTwo36FadeInUpsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt} {...(typeof teamSectionTwo36FadeInUpsImageProps === "function" ? teamSectionTwo36FadeInUpsImageProps(item) : (teamSectionTwo36FadeInUpsImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "hover-icons"}>
                                            {renderItemNode(teamSectionTwo36FadeInUpsButtonVisible, teamSectionTwo36FadeInUpsButtonRenderer, item, (
                                                <button type="button" className={item.button0ClassName ?? "add-icon"} {...(typeof teamSectionTwo36FadeInUpsButtonProps === "function" ? teamSectionTwo36FadeInUpsButtonProps(item) : (teamSectionTwo36FadeInUpsButtonProps ?? {}))} {...(typeof divDiv0Div0Div0Button0ButtonProps === "function" ? divDiv0Div0Div0Button0ButtonProps(item) : (divDiv0Div0Div0Button0ButtonProps ?? {}))}>
                                                    <i className={item.i0ClassName ?? "isax isax-add"} />
                                                </button>
                                            ))}
                                            <div className="social-icons">
                                                {renderCollectionNode(
                                                    item.socialIconsItems ?? [],
                                                    (item: TeamSectionTwoDivsItem) => (
                                                        renderItemNode(teamSectionTwoDivsLinkVisible, teamSectionTwoDivsLinkRenderer, item, (
                                                            <SmartLink href={item.href ?? "#"} aria-label={item.ariaLabel} {...(typeof teamSectionTwoDivsLinkProps === "function" ? teamSectionTwoDivsLinkProps(item) : (teamSectionTwoDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                                <i className={item.className} />
                                                            </SmartLink>
                                                        ))
                                                    ),
                                                    teamSectionTwoDivsItemWrapper,
                                                    teamSectionTwoDivsRenderer
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "team-content"}>
                                        {renderItemNode(teamSectionTwo36FadeInUpsH3Visible, teamSectionTwo36FadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof teamSectionTwo36FadeInUpsH3Props === "function" ? teamSectionTwo36FadeInUpsH3Props(item) : (teamSectionTwo36FadeInUpsH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSectionTwo36FadeInUpsLinkVisible, teamSectionTwo36FadeInUpsLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "all_routes.doctorProfile1"} {...(typeof teamSectionTwo36FadeInUpsLinkProps === "function" ? teamSectionTwo36FadeInUpsLinkProps(item) : (teamSectionTwo36FadeInUpsLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSectionTwo36FadeInUpsItemWrapper,
                        teamSectionTwo36FadeInUpsRenderer
                    )}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid team-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourteenTeamSectionTwoGenerated;
